/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import classNames from 'classnames';

import { Image, MobilePopupBottom } from '@lt/components';
import Popup from 'src/components/Popup';
import type { CheckoutFlightsBannerData } from '../types';
import styles from './CheckoutFlightsBanner.module.css';
import {
  BANNER_BLOCK_TEST_ID,
  BANNER_CONTAINER_TEST_ID,
  BANNER_TEXT_TEST_ID,
  BANNER_TEXT_WRAPPER_TEST_ID,
} from './constants';

const popupClassNames = {
  modal: styles.modalPopup,
  overlay: styles.bannerPopup,
};

const closeButtonStyles = {
  width: '16px',
  height: '16px',
  right: '16px',
  top: '12px',
  cursor: 'pointer',
};

const CheckoutFlightsBanner = ({
  title,
  fullText,
  imageSrc,
  imageFallback,
  isMobile,
}: CheckoutFlightsBannerData): JSX.Element => {
  const [isPopupOpened, setPopupOpened] = useState<boolean>(false);
  const onOpenPopup = () => {
    setPopupOpened(true);
  };
  const onClosePopup = () => {
    setPopupOpened(false);
  };
  const options = {
    showHandlebar: true,
  };

  return (
    <div className={classNames({ [styles.fullBannerContainer]: !isMobile })}>
      <div
        className={classNames({
          [styles.bannerContainer]: !isMobile,
          [styles.bannerContainerMobile]: isMobile,
        })}
        onClick={onOpenPopup}
        data-testid={BANNER_CONTAINER_TEST_ID}
      >
        <div
          className={classNames({
            [styles.bannerBlock]: !isMobile,
            [styles.bannerBlockMobile]: isMobile,
          })}
          data-testid={BANNER_BLOCK_TEST_ID}
        >
          <div
            className={classNames({
              [styles.bannerTextWrapper]: !isMobile,
              [styles.bannerTextWrapperMobile]: isMobile,
            })}
            data-testid={BANNER_TEXT_WRAPPER_TEST_ID}
          >
            <p
              className={classNames({
                [styles.bannerText]: !isMobile,
                [styles.bannerTextMobile]: isMobile,
              })}
              data-testid={BANNER_TEXT_TEST_ID}
            >
              {title}
            </p>
          </div>
          <div className={styles.bannerImageWrapper}>
            <Image
              src={imageSrc}
              fallback={imageFallback}
              className={styles.image}
            />
          </div>
        </div>
      </div>

      {isMobile ? (
        <MobilePopupBottom
          visible={isPopupOpened}
          onClick={onClosePopup}
          options={options}
          className={styles.popupMobileContainer}
        >
          <div className={styles.popupMobileBlock}>
            <p className={styles.popupMobileTitle}>{title}</p>
            <p className={styles.popupText}>{fullText}</p>
          </div>
        </MobilePopupBottom>
      ) : (
        <Popup
          open={isPopupOpened}
          onClose={onClosePopup}
          classNames={popupClassNames}
          closeButtonStyles={closeButtonStyles}
          closeOnOverlayClick
        >
          <div className={styles.popupBlock}>
            <p className={styles.popupTitle}>{title}</p>
            <p className={styles.popupText}>{fullText}</p>
          </div>
        </Popup>
      )}
    </div>
  );
};

export default CheckoutFlightsBanner;
